import { atom } from "jotai";
import { useUpdateAtom } from "jotai/utils";
import React from "react";
import { NotificationData } from "../messages";
import { List } from "../utils/List";

interface Params {
  name: string;
  disableIf: (notification?: NotificationData) => boolean;
}

export const disablePushNotificationsChecksAtom = atom<List<Params>>(List.empty<Params>());

function useDisablePushNotifications(params: Params) {
  const updateChecks = useUpdateAtom(disablePushNotificationsChecksAtom);
  const paramsRef = React.useRef(params);

  React.useEffect(() => {
    const { current: actualParams } = paramsRef;

    updateChecks((checks) => checks.append(actualParams));

    return () => {
      updateChecks((checks) => checks.filter((check) => check.name !== actualParams.name));
    };
  }, [updateChecks]);
}

export default useDisablePushNotifications;
